import { heroEquipment } from "../HeroEquipment";

export const skryre = {
  heroes: {
    Spaczinżynier: {
      id: 0,
      startingEquipment: ["Sztylet", "Spaczostrza"],
      cost: 65,
      number: 1,
      equipmentList: heroEquipment["Harcownicy klanu Skryre"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 4, 4, 3, 3, 2, 5, 1, 7],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: [
        "Dowódca",
        "Inżynier",
        "Ranger",
        "Strachliwy",
        "Technomanta",
        "W nogi!",
      ],
      exp: 20,
      skills: [0, 1, 2, 4, 5],
    },
    Kulomiotacz: {
      id: 1,
      startingEquipment: ["Sztylet", "Kula trującego wichru"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Harcownicy klanu Skryre"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 3, 4, 3, 3, 1, 5, 1, 5],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Maska przeciwgazowa", "Ranger", "W nogi!", "Życie jest tanie"],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    Czarnoszczur: {
      id: 2,
      startingEquipment: ["Sztylet", "Halabarda"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Harcownicy klanu Skryre"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 4, 3, 3, 3, 1, 5, 1, 5],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Krzepki", "Podoficer", "Ranger", "W nogi!", "Zimnokrwisty"],
      exp: 8,
      skills: [0, 1, 3, 4, 5],
    },
    "Łowca niewolników": {
      id: 3,
      startingEquipment: ["Sztylet", "Łapacz"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Harcownicy klanu Skryre"].Bohaterowie,
      type: "Bohater",
      stats: {
        "Początkowa": [5,3,3,3,3,1,5,1,5],
        "Maksymalna": [6,6,6,4,4,3,7,4,7]
      },
      rules: ["Handlarz niewolników", "Ranger", "W nogi!"],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    Niewolnik: {
      id: 4,
      startingEquipment: ["Broń improwizowana"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 2],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mięso armatnie", "Niewolnik", "Rozmiar rzondzi"],
    },
    Klanbrat: {
      id: 5,
      startingEquipment: ["Sztylet", "Włócznia"],
      cost: 20,
      number: 15,
      equipmentList: heroEquipment["Harcownicy klanu Skryre"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [5, 3, 3, 3, 3, 1, 4, 1, 5],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Chorążowie & sygnaliści", "Ranger", "W nogi!"],
    },
    Harcownik: {
      id: 6,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 30,
      number: 7,
      equipmentList: heroEquipment["Harcownicy klanu Skryre"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [5, 4, 3, 3, 3, 1, 5, 1, 6],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Drużyna ciężkich broni (kulomiot, spaczrusznica, miotacz spaczognia, moździerz trującego wichru)","Drużyna obsługi","Ranger","Szermierz","W nogi!"],
    },
    "Drużyna ciężkich broni": {
      id: 7,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 60,
      number: 2,
      equipmentList: heroEquipment["Harcownicy klanu Skryre"].Ciężcy,
      type: "Stronnik",
      stats: {
        Początkowa: [5, 4, 3, 3, 3, 1, 5, 1, 6],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: [
        "Drużyna ciężkich broni",
        "Drużyna obsługi",
        "Ranger",
        "Szermierz",
        "W nogi!",
      ],
    },
    "Szczurogr klanu Skryre": {
      id: 8,
      startingEquipment: ["Broń naturalna"],
      cost: 180,
      number: 1,
      equipmentList: heroEquipment["Harcownicy klanu Skryre"].Szczurogr,
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 3, 5, 4, 3, 4, 3, 5],
        Maksymalna: [6, 3, 3, 5, 4, 3, 4, 3, 5],
      },
      rules: ["Bycza szarża","Duży cel","Głód trzewi","Konstrukt","Łuskowata skóra (4+)","Murołaz","Niezłomny","Nieświadomy","Przepastne trzewia","Strach","Wielkolud","Zbrojne ramię"],
    },
    "Koło zagłady": {
      id: 9,
      startingEquipment: [],
      cost: 150,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["3K6", "-", "-", 5, 5, 8, "-", "-", "-"],
        "Wielkie Szczury": ["-", 2, 0, 3, "-", "-", 4, "K3", 3],
      },
      rules: [
        "Duży cel",
        "Machina wojenna",
        "No to hooop!",
        "Rydwan",
        "Strach",
        "Zzzzap!",
      ],
    },
    Więźniarka: {
      id: 10,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Wilkoszczur: [9, 3, 0, 3, "-", "-", 4, 1, 3],
        "Wilkoszczur ": [9, 3, 0, 3, "-", "-", 4, 1, 3],
      },
      rules: ["Duży cel", "Machina wojenna", "Powóz", "Więźniarka"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Harcownicy klanu Skryre",
  nature: "Chaotyczna",
  armyRules: ["Rozrzutność"],
  mercenaries: ["Szczurogr", "Szpieg", "Złodziej"],
};
